Ext.ns('mx.comp');

mx.comp.PeriodField = Ext.extend(mx.comp.FieldGroup, {
    spinnerWidth: 70,

    errorMessage: '',

    spinnerStrategy: {
        xtype: 'number',
        minValue: 0,
    },

    spinnerDefaultValue: 0,

    comboWidth: 90,

    comboDataFields: ['interval_id', 'interval_name'],

    labels: {
        seconds: 'seconds',
        minutes: 'minutes',
        hours: 'hours',
        days: 'days',
        weeks: 'week',
    },

    comboData: null,

    comboDefaultValue: 'h',

    comboValueField: 'interval_id',

    comboDisplayField: 'interval_name',

    textWidth: 1.0,

    text: '',

    isFieldContainer: false,

    minValue: 0,

    validator: function() {
        return true;
    },

    isDirty: function() {
        if (this.disabled) {
            return false;
        }
        return String(this.getValue()) !== String(this.originalValue);
    },

    initComponent: function() {
        var thiz = this;

        this.comboData = this.comboData || [
            ['s', MXBT.get('LOC')['mx.comp.PeriodField']['seconds'] || this.labels.seconds],
            ['m', MXBT.get('LOC')['mx.comp.PeriodField']['minutes'] || this.labels.minutes],
            ['h', MXBT.get('LOC')['mx.comp.PeriodField']['hours'] || this.labels.hours],
            ['d', MXBT.get('LOC')['mx.comp.PeriodField']['days'] || this.labels.days],
            ['w', MXBT.get('LOC')['mx.comp.PeriodField']['weeks'] || this.labels.weeks],
        ];

        mx.comp.PeriodField.superclass.initComponent.call(this);

        this.columns = [this.spinnerWidth, this.comboWidth, this.textWidth];

        this.defaults = {
            anchor: '-5',
        };

        if (!this.comboStore) {
            this.comboStore = new Ext.data.SimpleStore({
                fields: this.comboDataFields,
                data: this.comboData,
            });
        }

        this.name = this.name || this.id;

        this.items = [
            (this.spinner = new Ext.ux.form.Spinner({
                scope: this,
                strategy: this.spinnerStrategy,
                name: this.name + '-value',
                value: this.spinnerDefaultValue,
                allowBlank: this.allowBlank,
                validateValue: function() {
                    if (this.scope.getValue() > this.scope.maxValue || this.scope.getValue() < this.scope.minValue) {
                        this.errorMessage = 'Invalid value';
                        this.markInvalid(this.scope.errorMessage);
                        return false;
                    }
                    if (this.scope.validator(this.getValue())) {
                        this.clearInvalid();
                        return true;
                    } else {
                        this.markInvalid(this.scope.errorMessage);
                        return false;
                    }
                },
                listeners: {
                    change: function() {
                        thiz.setValue(thiz.calcValueInSeconds(thiz.spinner.el.dom.value));
                    },
                },
            })),
            (this.combo = new Ext.form.ComboBox({
                name: this.name + '-interval',
                mode: 'local',
                editable: false,
                forceSelection: true,
                triggerAction: 'all',
                valueField: this.comboValueField,
                displayField: this.comboDisplayField,
                store: this.comboStore,
                value: this.comboDefaultValue,
            })),
            {
                xtype: 'label',
                text: this.text,
            },
        ];
    },

    setValue: function(/*int*/ seconds, interval) {
        var multiplier;
        if (interval) {
            this.setUnits(interval);
            multiplier = this.getSecondsMultiplier();
        } else {
            var allowWeek = false;
            var allowDay = false;
            var allowHour = false;
            var allowMinute = false;
            var allowSeconds = false;
            for (var i = 0; i < this.comboData.length; i++) {
                if (this.comboData[i][0] == 's') {
                    allowSeconds = true;
                }
                if (this.comboData[i][0] == 'm') {
                    allowMinute = true;
                }
                if (this.comboData[i][0] == 'h') {
                    allowHour = true;
                }
                if (this.comboData[i][0] == 'd') {
                    allowDay = true;
                }
                if (this.comboData[i][0] == 'w') {
                    allowWeek = true;
                }
            }

            if (seconds < 60 && allowSeconds) {
                this.combo.setValue('s');
                multiplier = 1;
            } else if (allowMinute) {
                this.combo.setValue('m');
                multiplier = 1 / 60;
            } else if (allowWeek && seconds % (60 * 60 * 24 * 7) == 0) {
                //week
                this.combo.setValue('w');
                multiplier = 1 / (60 * 60 * 24 * 7);
            } else if (allowDay && seconds % (60 * 60 * 24) == 0) {
                //day
                this.combo.setValue('d');
                multiplier = 1 / (60 * 60 * 24);
            } else if (allowHour && seconds % (60 * 60) == 0) {
                //hour
                this.combo.setValue('h');
                multiplier = 1 / (60 * 60);
            } else if (allowMinute && seconds % 60 == 0) {
                //minute
                this.combo.setValue('m');
                multiplier = 1 / 60;
            } else if (allowMinute) {
                this.combo.setValue('m');
                multiplier = 1 / 60;
            } else if (allowSeconds) {
                this.combo.setValue('s');
                multiplier = 1;
            }
        }
        seconds = seconds.toString().replace(',', '.');
        this.spinner.setValue(Math.round(seconds * multiplier * 100) / 100 || 0);
        this.validate();
    },

    getValue: function() {
        return this.calcValueInSeconds(this.spinner.getValue());
    },

    getSecondsMultiplier: function() {
        var u = this.combo.getValue();
        switch (u) {
            case 's': {
                return 1;
            }
            case 'm': {
                return 1 / 60;
            }
            case 'h': {
                return 1 / 3600;
            }
            case 'd': {
                return 1 / 3600 / 24;
            }
            case 'w': {
                return 1 / 3600 / 24 / 7;
            }
        }
        return 0;
    },

    getUnits: function() {
        var u = this.combo.getValue();
        switch (u) {
            case 's': {
                return 1;
            }
            case 'm': {
                return 2;
            }
            case 'h': {
                return 3;
            }
            case 'd': {
                return 4;
            }
            case 'w': {
                return 5;
            }
        }
        return 0;
    },

    setUnits: function(u) {
        switch (u) {
            case 1: {
                this.combo.setValue('s');
                break;
            }
            case 2: {
                this.combo.setValue('m');
                break;
            }
            case 3: {
                this.combo.setValue('h');
                break;
            }
            case 4: {
                this.combo.setValue('d');
                break;
            }
            case 5: {
                this.combo.setValue('w');
                break;
            }
            default:
                this.combo.setValue('h');
                break;
        }
    },
    calcValueInSeconds: function(v) {
        var mult = 0;
        var interval = this.combo.getValue();
        switch (interval) {
            case 's': {
                mult = 1;
                break;
            }
            case 'm': {
                mult = 60;
                break;
            }
            case 'h': {
                mult = 3600;
                break;
            }
            case 'd': {
                mult = 3600 * 24;
                break;
            }
            case 'w': {
                mult = 3600 * 24 * 7;
                break;
            }
        }
        return Math.round(MXBT.parseDouble(v) * mult) || 0;
    },

    getName: function() {
        return this.name;
    },

    validate: function() {
        if (!this.allowBlank && !this.spinner.validate()) {
            this.spinner.markInvalid(this.blankText);
            return false;
        } else {
            this.spinner.clearInvalid();
            return true;
        }
    },
});

Ext.reg('mx_periodfield', mx.comp.PeriodField);
